import { readState } from "@/__main__/app-state.mjs";
import { appURLs } from "@/app/app-urls.mjs";
import type { GameNavItem } from "@/app/constants-nav.mjs";
import type { GameDefinition } from "@/app/game-definition.mjs";
import { /* OVERLAY_IDS, */ TDM_MAPS } from "@/game-val/constants.mjs";
import { GAME_SYMBOL_VAL } from "@/game-val/definition-symbol.mjs";
import overlayRoutes from "@/game-val/overlay-routes.mjs";
import routes from "@/game-val/routes.mjs";
import GameIconBoxVal from "@/inline-assets/game-icon-box-val.svg";
import FriendGameIconBoxVal from "@/inline-assets/game-icon-friend-box-val.svg";
import GameShapeVal from "@/inline-assets/GameShapeVal.svg";

// const VAL_OVERLAY_SETTINGS = {
//   isLoadingScreenEnabled: true,
//   isAgentSelectEnabled: true,
//   isBenchmarkOverlayEnabled: true,
//   isCombatOverlayEnabled: true,
//   dynamicStats: {
//     displayOption: "all",
//     perRound: true,
//     combatScore: true,
//     abilityKills: true,
//     kills: true,
//     headshotKills: false,
//     assists: false,
//     damage: false,
//     headshotPercent: false,
//     benchmarkOption: 0,
//     accuracy: false,
//     reactionTime: true,
//     manualSetRank: false,
//     rank: "platinum",
//     manualOverlayPosition: false,
//     overlayPosition: "centered",
//   },
//   positions: Object.values(OVERLAY_IDS).reduce((acc, id) => {
//     acc[id] = { x: 0, y: 0, isDragged: false };
//     return acc;
//   }, {}),
// };

export { GAME_SYMBOL_VAL };

const definition = {
  gameSymbol: GAME_SYMBOL_VAL,
  icon: `${appURLs.CDN_PLAIN}/blitz/ui/images/icons/games/small/VAL-small.svg`,
  iconShape: GameShapeVal,
  iconBox: GameIconBoxVal,
  iconBadge: FriendGameIconBoxVal,
  imageHero: `${appURLs.CDN_PLAIN}/blitz/games/assest/hero-logo/hero-logo-valorant.png`,
  imageBanner: `${appURLs.CDN}/blitz/library/banner-valorant.webp`,
  imageKeyart: `${appURLs.CDN}/blitz/ui/img/game-cover/val-min.webp`,
  imageWordmark: `${appURLs.CDN}/blitz/ui/img/gamecover/name-val.webp`,
  isActive: true,
  fullName: ["common:games.val.long", "Valorant"],
  friendlyName: ["common:games.val.short", "VALORANT"],
  preferFriendlyName: true as const,
  shortName: "valorant" as const,
  backendName: "VALORANT" as const,
  gameColor: "#FF4654",
  playerNameHash: true,

  IPC: () => import("@/game-val/init.mjs"),

  settings: () => import("@/game-val/ValorantSettings.jsx"),

  routes,
  overlayRoutes,

  // overlays: {
  //   agentSelect: {
  //     key: ["isAgentSelectEnabled"],
  //     title: ["overlays:val.agentSelect.title", "Agent Select"],
  //     description: [
  //       "overlays:val.agentSelect.description",
  //       "See players' ranks and stats from matches from the current act and game mode during agent select.",
  //     ],
  //     tags: ["performance"],
  //     images: {
  //       large: `${appURLs.CDN}/blitz/ui/img/settings/valOverlay/agent-select-portrait.webp`,
  //       small: `${appURLs.CDN}/blitz/ui/img/settings/valOverlay/val-agent-select.webp`,
  //     },
  //     date: new Date(2021, 1, 3),
  //   },
  //   valLoadingScreen: {
  //     key: ["isLoadingScreenEnabled"],
  //     title: ["overlays:val.loadingScreen.title", "Loading Screen"],
  //     tags: ["tracker"],
  //     description: [
  //       "overlays:val.loadingScreen.description",
  //       "See players' ranks and statistics from matches from the current act and game mode with AI win prediction on loading screen.",
  //     ],
  //     brief: [
  //       "overlays:val.loadingScreen.brief",
  //       "See players' ranks and statistics from the current act and game mode in loading screen.",
  //     ],
  //     images: {
  //       large: `${appURLs.CDN}/blitz/ui/img/settings/valOverlay/loading-screen-portrait.webp`,
  //       small: `${appURLs.CDN}/blitz/ui/img/settings/valOverlay/val-loading-screen.webp`,
  //     },
  //     date: new Date(2021, 4, 3),
  //   },
  //   valBenchmark: {
  //     key: ["isBenchmarkOverlayEnabled"],
  //     title: ["overlays:postmatchInsights.title", "Post Match Insights"],
  //     tags: ["performance"],
  //     description: [
  //       "overlays:postmatchInsights.desc",
  //       "Automatically pop up in-depth statistics as soon as your game ends. The post match overlay can be collapsed into a minimized version, which is draggable and closable after a few seconds. Premium users unlock the ability to toggle the post-match overlay on/off.",
  //     ],
  //     brief: [
  //       "overlays:postmatchInsights.brief",
  //       "Automatically pop up in-depth statistics as soon as your game ends.",
  //     ],
  //     images: {
  //       large: `${appURLs.CDN}/blitz/ui/img/settings/valOverlay/benchmark-overlay.webp`,
  //       small: `${appURLs.CDN}/blitz/ui/img/settings/valOverlay/val-post-match-insights.webp`,
  //     },
  //     date: new Date(2022, 11, 17),
  //   },
  //   valCombat: {
  //     key: ["isCombatOverlayEnabled"],
  //     title: ["overlays:dynamicStats.title", "Dynamic Stats"],
  //     tags: ["tracker"],
  //     description: [
  //       "overlays:dynamicStats.desc",
  //       "Track key combat metrics to better gauge performance in real time.",
  //     ],
  //     brief: [
  //       "overlays:dynamicStats.brief",
  //       "Track key combat metrics to better gauge performance in real time.",
  //     ],
  //     images: {
  //       large: `${appURLs.CDN}/blitz/ui/img/settings/valOverlay/dynamic-stats-overlay.webp`,
  //       small: `${appURLs.CDN}/blitz/ui/img/settings/valOverlay/val-dynamic-stats.webp`,
  //     },
  //     date: new Date(2022, 11, 18),
  //     features: [
  //       {
  //         text: ["overlays:inGameConfig.title", "Options"],
  //         items: [
  //           {
  //             text: [
  //               "overlays:inGameConfig.description",
  //               "Disable the overlay and toggle key stats in game.",
  //             ],
  //           },
  //         ],
  //       },
  //       {
  //         text: [
  //           "overlays:val.dynamicStats.options.displayOptions.title",
  //           "Display Options",
  //         ],
  //         items: [
  //           {
  //             text: [
  //               "overlays:val.dynamicStats.options.displayOptions.desc",
  //               "How would you like your overlay to behave?",
  //             ],
  //             select: {
  //               key: ["dynamicStats", "displayOption"],
  //               options: [
  //                 {
  //                   value: "all",
  //                   text: [
  //                     "overlays:val.dynamicStats.options.displayOptions.all",
  //                     "All",
  //                   ],
  //                   image: `${appURLs.CDN}/blitz/ui/img/settings/valOverlay/display-all.webp`,
  //                 },
  //                 {
  //                   value: "combatOnly",
  //                   text: [
  //                     "overlays:val.dynamicStats.options.displayOptions.combatOnly",
  //                     "Combat Only",
  //                   ],
  //                   image: `${appURLs.CDN}/blitz/ui/img/settings/valOverlay/display-combat-only.webp`,
  //                 },
  //                 {
  //                   value: "scoreboardOnly",
  //                   text: [
  //                     "overlays:val.dynamicStats.options.displayOptions.scoreboardOnly",
  //                     "Scoreboard Only",
  //                   ],
  //                   image: `${appURLs.CDN}/blitz/ui/img/settings/valOverlay/display-scoreboard-only.webp`,
  //                 },
  //               ],
  //             },
  //           },
  //           {
  //             title: [
  //               "overlays:val.dynamicStats.options.displayOptions.perRound",
  //               "Per Round",
  //             ],
  //             toggle: { key: ["dynamicStats", "perRound"] },
  //           },
  //           {
  //             title: [
  //               "overlays:val.dynamicStats.options.displayOptions.combatScore",
  //               "Combat Score",
  //             ],
  //             toggle: { key: ["dynamicStats", "combatScore"] },
  //           },
  //           {
  //             title: [
  //               "overlays:val.dynamicStats.options.displayOptions.abilityKills",
  //               "Ability Kills",
  //             ],
  //             toggle: { key: ["dynamicStats", "abilityKills"] },
  //           },
  //           {
  //             title: [
  //               "overlays:val.dynamicStats.options.displayOptions.kills",
  //               "Kills",
  //             ],
  //             toggle: { key: ["dynamicStats", "kills"] },
  //           },
  //           {
  //             title: [
  //               "overlays:val.dynamicStats.options.displayOptions.headshotKills",
  //               "Headshot Kills",
  //             ],
  //             toggle: { key: ["dynamicStats", "headshotKills"] },
  //           },
  //           {
  //             title: [
  //               "overlays:val.dynamicStats.options.displayOptions.assists",
  //               "Assists",
  //             ],
  //             toggle: { key: ["dynamicStats", "assists"] },
  //           },
  //           {
  //             title: [
  //               "overlays:val.dynamicStats.options.displayOptions.damage",
  //               "Damage",
  //             ],
  //             toggle: { key: ["dynamicStats", "damage"] },
  //           },
  //           {
  //             title: [
  //               "overlays:val.dynamicStats.options.displayOptions.headshotPercent",
  //               "Headshot %",
  //             ],
  //             toggle: { key: ["dynamicStats", "headshotPercent"] },
  //           },
  //           {
  //             title: [
  //               "overlays:val.dynamicStats.options.displayOptions.accuracy",
  //               "Accuracy",
  //             ],
  //             toggle: { key: ["dynamicStats", "accuracy"] },
  //           },
  //           {
  //             title: [
  //               "overlays:val.dynamicStats.options.displayOptions.reactionTime",
  //               "Reaction Time",
  //             ],
  //             toggle: { key: ["dynamicStats", "reactionTime"] },
  //           },
  //         ],
  //       },
  //       {
  //         text: [
  //           "overlays:val.dynamicStats.options.benchmarkOptions.title",
  //           "Benchmark Options",
  //         ],
  //         items: [
  //           {
  //             text: [
  //               "overlays:val.dynamicStats.options.benchmarkOptions.desc",
  //               "How would you like your overlay to behave?",
  //             ],
  //             select: {
  //               key: ["dynamicStats", "benchmarkOption"],
  //               style: "radio",
  //               options: [
  //                 {
  //                   value: 0,
  //                   text: [
  //                     "overlays:val.dynamicStats.options.benchmarkOptions.vsTeammates",
  //                     "vs Teammates",
  //                   ],
  //                 },
  //                 {
  //                   value: 1,
  //                   text: [
  //                     "overlays:val.dynamicStats.options.benchmarkOptions.vsLobby",
  //                     "vs Lobby",
  //                   ],
  //                 },
  //               ],
  //             },
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },
  // overlaySettingsKey: "valOverlaySettings",
  // overlaySettings: VAL_OVERLAY_SETTINGS,
  meta: {
    overlays: {
      title: ["overlays:meta.val.title", "VALORANT Overlays"],
      description: [
        "overlays:meta.val.description",
        "Elevate your VALORANT experience with our exclusive collection of overlays, designed to enhance your gameplay with real time stats and insights.",
      ],
      subtitle: [
        "overlays:meta.val.subtitle",
        "All the guides you need to dominate VALORANT. VAL stats, agents, lineups, leaderboards, and more.",
      ],
    },
    game: {
      title: [
        "home:meta.home.val.title",
        "Valorant Tracker - The Best Stats, Leaderboards, and Insights with Blitz.gg",
      ],
      description: [
        "home:meta.home.val.description",
        "Use Blitz.gg's Valorant Tracker to monitor your stats, track performance, and win more games. Download our desktop app for the best tracking tools and premium real-time overlays!",
      ],
    },
    pros: [
      {
        name: "SEN Tenz",
        src: "sen-tenz-af1ed4.webp",

        id: "sen tenz-0505",
      },
      {
        name: "FNC Boaster",
        src: "fnc-boaster-6261c8.webp",

        id: "fnatic boaster-1010",
      },
      {
        name: "NRG FNS Optic",
        src: "nrg-fns-optic-070fd4.webp",

        id: "nrg fns-daddy",
      },
      {
        name: "Cryocells",
        src: "cryocells-71e26d.webp",

        id: "cryocells-taffy",
      },
    ],
    bg: `${appURLs.CDN}/blitz/ui/img/game-bg/val-3734b.webp`,
    bgVideo: `${appURLs.CDN_VIDEOS}/homepage/val-homepage-bg-video.mp4`,
    players: "45M+",
    matches: "525M+",
    guides: [
      () => import("@/game-val/HomeAgentStatsTile.jsx"),
      () => import("@/game-val/HomeLineupsTile.jsx"),
    ],
    features: [
      {
        title: ["val.features.profile-page.title", "Profile Page"],
        description: [
          "val.features.profile-page.description",
          "Track valuable metrics over time to measure your gaming performance",
        ],
        image: `${appURLs.CDN}/blitz/ui/img/homepage/valorant/profile-page.webp`,
      },
      {
        title: ["val.features.leaderboard.title", "Leaderboard"],
        description: [
          "val.features.leaderboard.description",
          "See how you stack up against the best players from around the world",
        ],
        image: `${appURLs.CDN}/blitz/ui/img/homepage/valorant/leaderboard.webp`,
      },
      {
        title: [
          "val.features.dynamic-stats-overlay.title",
          "Dynamic Stats Overlay",
        ],
        description: [
          "val.features.dynamic-stats-overlay.description",
          "Track and benchmark key stats in real-time",
        ],
        image: `${appURLs.CDN}/blitz/ui/img/homepage/valorant/dynamic-stats-overlay.webp`,
      },
      {
        title: [
          "val.features.agent-select-overlay.title",
          "Agent Select Overlay",
        ],
        description: [
          "val.features.agent-select-overlay.description",
          "See players' ranks and statistics from their last 5 competitive matches in agent select",
        ],
        image: `${appURLs.CDN}/blitz/ui/img/homepage/valorant/agent-select-overlay.webp`,
      },
      {
        title: [
          "val.features.loading-screen-overlay.title",
          "Loading Screen Overlay",
        ],
        description: [
          "val.features.loading-screen-overlay.description",
          "See players' ranks and statistics from last 5 matches in loading screen",
        ],
        image: `${appURLs.CDN}/blitz/ui/img/homepage/valorant/loading-screen-overlay.webp`,
      },
      {
        title: [
          "val.features.post-match-insights-overlay.title",
          "Post Match Insights Overlay",
        ],
        description: [
          "val.features.post-match-insights-overlay.description",
          "Automatically view and benchmark key stats as soon as your match ends",
        ],
        image: `${appURLs.CDN}/blitz/ui/img/homepage/valorant/post-match-insights-overlay.webp`,
      },
      {
        title: ["val.features.agent-statistics.title", "Agent Statistics"],
        description: [
          "val.features.agent-statistics.description",
          "Check out the most popular Agents played",
        ],
        image: `${appURLs.CDN}/blitz/ui/img/homepage/valorant/agent-statistics.webp`,
      },
      {
        title: ["val.features.weapon-statistics.title", "Weapon Statistics"],
        description: [
          "val.features.weapon-statistics.description",
          "Check out the most popular Weapons played",
        ],
        image: `${appURLs.CDN}/blitz/ui/img/homepage/valorant/weapon-statistics.webp`,
      },
      {
        title: ["val.features.map-statistics.title", "Map Statistics"],
        description: [
          "val.features.map-statistics.description",
          "Check out the most popular Maps played",
        ],
        image: `${appURLs.CDN}/blitz/ui/img/homepage/valorant/map-statistics.webp`,
      },
      {
        title: ["val.features.lineup-guide.title", "Lineup Guide"],
        description: [
          "val.features.lineup-guide.description",
          "Review the best attacking and defending positions",
        ],
        image: `${appURLs.CDN}/blitz/ui/img/homepage/valorant/lineup-guide.webp`,
      },
      {
        title: ["val.features.agent-guide.title", "Agent Guide"],
        description: [
          "val.features.agent-guide.description",
          "See all agent's abilities, lineups, insights and more",
        ],
        image: `${appURLs.CDN}/blitz/ui/img/homepage/valorant/agent-guide.webp`,
      },
      {
        title: ["val.features.weapon-guide.title", "Weapon Guide"],
        description: [
          "val.features.weapon-guide.description",
          "Check out in depth stats on every weapon in the game",
        ],
        image: `${appURLs.CDN}/blitz/ui/img/homepage/valorant/weapon-guide.webp`,
      },
    ],
    homeData: () => import("@/game-val/home-fetch-val-data.mjs"),
  },
  navLinks: [
    {
      href: `/valorant/stats`,
      text: ["common:navigation.statistics", "Statistics"],
      menu: [
        [
          {
            items: [
              {
                text: ["common:navigation.agents", "Agents"],
                href: `/valorant/stats/agents`,
              },
              {
                text: ["common:navigation.weapons", "Weapons"],
                href: `/valorant/stats/weapons`,
              },
              {
                text: ["common:navigation.maps", "Maps"],
                href: `/valorant/stats/maps`,
              },
            ],
          },
        ],
      ],
    },
    {
      href: `/valorant/leaderboards/official`,
      text: ["common:navigation.leaderboards", "Leaderboards"],
    },
    proxyLineups({
      href: `/valorant/lineups`,
      text: ["common:navigation.lineups", "Lineups"],
      menu: [],
    }),
    {
      href: `/valorant/overlays`,
      text: ["common:navigation.overlays", "Overlays"],
      excludeSearch: true,
    },
    {
      href: `/valorant/agents`,
      text: ["val:navigation.agents", "Agents"],
    },
    {
      href: `/valorant/weapons`,
      text: ["common:navigation.weapons", "Weapons"],
    },
  ],
  homepageFeatures: [
    "blitz-search",
    {
      type: "contentful-articles",
      title: ["common:news.title", "News"],
      description: [
        "common:news.descriptionGame",
        "What’s new with {{gameName}}",
        {
          gameName: "Valorant",
        },
      ],
      // cta: {
      //   href: "/valorant/patch-notes",
      //   title: ["valorant:contentfularticles.cta.title", "View Patch Notes"],
      // },
    },
    "blitz-guides",
    {
      type: "contentful-grid",
      title: ["valorant:agentGuides.title", "Agent Guides"],
      description: [
        "valorant:agentGuides.description",
        "Stay up to date with the latest Valorant Agent guides",
      ],
      cta: {
        href: "/valorant/guides",
        title: ["valorant:contentfularticles.cta.title", "View All Guides"],
      },
    },
    "blitz-game-features",
  ],
} satisfies GameDefinition<typeof GAME_SYMBOL_VAL>;

function proxyLineups(def: GameNavItem): GameNavItem {
  const p = new Proxy(def, {
    get(target, prop, receiver) {
      if (prop === "menu") {
        const mapsList = readState.val.cms.maps
          .filter(
            (l: { key: string; name: string }) => !TDM_MAPS.includes(l.key), // We don't have TDM lineups
          )
          .map((l: { key: string; name: string }) => ({
            href: `/valorant/lineups?map=${l.key}`,
            text: l.name,
            ...l,
          }))
          .sort((l, r) => (r.key < l.key ? 1 : -1));
        return [[{ items: mapsList }]];
      }
      return Reflect.get(target, prop, receiver);
    },
  });
  return p;
}

export default definition;
